export interface CancelRegisterSeeHouseForm {
  type: 'default' | 'others';
  reason?: string;
}

export const cancelRegisterSeeHouseFormDefaultValues: CancelRegisterSeeHouseForm = {
  type: 'default',
  reason: undefined,
};
